export default __webpack_public_path__ + "static/logo-en-f7b27e7774af87453df8b2a145f7de64.svg";